// Full box score data for all mock final games.
// Keyed by game ID from odds.js MOCK_GAMES.

const BOX_SCORES = {

  // ── nba_g1: NYK 112, CLE 104 ────────────────────────────────────────────────
  'nba_g1': {
    sport: 'NBA',
    periods: [
      { label:'Q1', away:28, home:22 },
      { label:'Q2', away:24, home:30 },
      { label:'Q3', away:32, home:26 },
      { label:'Q4', away:28, home:26 },
    ],
    awayPlayers: [
      { name:'J. Brunson',    pts:32, reb:5,  ast:8, fg:'12-21', tpt:'4-8',  pm:'+14', highlight:true  },
      { name:'O. Anunoby',   pts:18, reb:6,  ast:2, fg:'7-13',  tpt:'2-5',  pm:'+8'                   },
      { name:'J. Hart',      pts:14, reb:11, ast:4, fg:'5-10',  tpt:'1-3',  pm:'+6'                   },
    ],
    homePlayers: [
      { name:'D. Mitchell',  pts:28, reb:4,  ast:6, fg:'10-22', tpt:'3-8',  pm:'-8'                   },
      { name:'E. Mobley',    pts:18, reb:12, ast:3, fg:'7-14',  tpt:'0-1',  pm:'-4'                   },
      { name:'M. Strus',     pts:14, reb:3,  ast:2, fg:'5-12',  tpt:'3-7',  pm:'-6'                   },
    ],
    awayTeam: { fgPct:48.2, tptPct:37.5, reb:44, ast:26, to:12, stl:8  },
    homeTeam: { fgPct:41.8, tptPct:33.3, reb:38, ast:20, to:15, stl:5  },
  },

  // ── nba_g6: MIN 108, PHX 99 ─────────────────────────────────────────────────
  'nba_g6': {
    sport: 'NBA',
    periods: [
      { label:'Q1', away:26, home:22 },
      { label:'Q2', away:30, home:25 },
      { label:'Q3', away:28, home:28 },
      { label:'Q4', away:24, home:24 },
    ],
    awayPlayers: [
      { name:'A. Edwards',    pts:26, reb:5,  ast:4, fg:'10-22', tpt:'2-7',  pm:'+10', highlight:true },
      { name:'J. McDaniels',  pts:18, reb:4,  ast:3, fg:'7-13',  tpt:'2-5',  pm:'+6'                  },
      { name:'R. Gobert',     pts:14, reb:14, ast:2, fg:'6-9',   tpt:'0-0',  pm:'+8'                  },
    ],
    homePlayers: [
      { name:'K. Durant',     pts:28, reb:7,  ast:4, fg:'11-20', tpt:'2-5',  pm:'-6',  highlight:true },
      { name:'D. Booker',     pts:24, reb:3,  ast:5, fg:'9-21',  tpt:'2-7',  pm:'-4'                  },
      { name:'J. Nurkic',     pts:12, reb:8,  ast:2, fg:'5-9',   tpt:'0-0',  pm:'-10'                 },
    ],
    awayTeam: { fgPct:44.8, tptPct:35.0, reb:46, ast:22, to:14, stl:6  },
    homeTeam: { fgPct:42.5, tptPct:32.1, reb:40, ast:21, to:13, stl:7  },
  },

  // ── mlb_g4: CHC 4, STL 2 ────────────────────────────────────────────────────
  'mlb_g4': {
    sport: 'MLB',
    periods: [
      { label:'1', away:0, home:0 }, { label:'2', away:1, home:0 },
      { label:'3', away:0, home:1 }, { label:'4', away:2, home:0 },
      { label:'5', away:0, home:0 }, { label:'6', away:0, home:1 },
      { label:'7', away:1, home:0 }, { label:'8', away:0, home:0 },
      { label:'9', away:0, home:0 },
    ],
    awayPlayers: [
      { name:'J. Steele',     role:'pitcher', ip:'6.1', h:6, er:2, k:7, bb:2, era:3.12 },
      { name:'B. Hughes',     role:'pitcher', ip:'1.2', h:1, er:0, k:2, bb:0, era:2.45 },
      { name:'I. Happ',       role:'batter',  ab:4, h:2, rbi:2, hr:1, avg:.278, highlight:true },
      { name:'D. Swanson',    role:'batter',  ab:4, h:2, rbi:1, hr:0, avg:.261 },
      { name:'C. Bellinger',  role:'batter',  ab:4, h:1, rbi:1, hr:0, avg:.241 },
    ],
    homePlayers: [
      { name:'M. Mikolas',    role:'pitcher', ip:'5.0', h:7, er:3, k:4, bb:1, era:4.12 },
      { name:'R. Helsley',    role:'pitcher', ip:'2.0', h:1, er:0, k:2, bb:0, era:1.98 },
      { name:'N. Arenado',    role:'batter',  ab:4, h:2, rbi:1, hr:1, avg:.271, highlight:true },
      { name:'P. Goldschmidt',role:'batter',  ab:4, h:1, rbi:1, hr:0, avg:.282 },
      { name:'L. Nootbaar',   role:'batter',  ab:3, h:1, rbi:0, hr:0, avg:.258 },
    ],
    awayTeam: { avg:.258, h:9, r:4, e:0, lob:7 },
    homeTeam: { avg:.236, h:7, r:2, e:1, lob:8 },
  },

  // ── nhl_g4: DAL 4, VGK 3 ────────────────────────────────────────────────────
  'nhl_g4': {
    sport: 'NHL',
    periods: [
      { label:'P1', away:1, home:0 },
      { label:'P2', away:2, home:1 },
      { label:'P3', away:1, home:2 },
    ],
    awayPlayers: [
      { name:'R. Hintz',      role:'skater', g:2, a:0, pts:2, pm:1,  sog:5, toi:'17:52', highlight:true },
      { name:'J. Robertson',  role:'skater', g:0, a:2, pts:2, pm:2,  sog:6, toi:'18:24' },
      { name:'J. Pavelski',   role:'skater', g:1, a:1, pts:2, pm:1,  sog:4, toi:'14:18' },
      { name:'J. Oettinger',  role:'goalie', sv:23, sa:26, svPct:.885 },
    ],
    homePlayers: [
      { name:'J. Eichel',     role:'skater', g:1, a:1, pts:2, pm:-1, sog:5, toi:'19:14' },
      { name:'W. Karlsson',   role:'skater', g:1, a:0, pts:1, pm:-1, sog:4, toi:'16:42' },
      { name:'M. Stone',      role:'skater', g:0, a:1, pts:1, pm:-2, sog:3, toi:'17:08' },
      { name:'A. Hill',       role:'goalie', sv:24, sa:28, svPct:.857 },
    ],
    awayTeam: { sog:28, foWPct:51.2, ppg:'1/3', hits:24, blk:15 },
    homeTeam: { sog:26, foWPct:48.8, ppg:'1/4', hits:28, blk:12 },
  },
}

export function getBoxScore(gameId) {
  return BOX_SCORES[gameId] ?? null
}
